// --------------------------------------------------------------------------
// #34 – Membership form
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

/* global dataLayer, picturefill, gift */

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = require('jquery');
var events = require('common-js-pub-sub')();
var detectIE = require('../utilities/detect-ie');
var getQueryVar = require('../utilities/get-query-var');
var getAllQueryVars = require('../utilities/get-all-query-vars');
var reinitModules = require('../utilities/reinit-modules');

// jquery plugins
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');

// expressive annotations
var ea = require('../plugins/expressive.annotations.validate');

/**
 * membership-journey
 */
module.exports = function (options) {

    var ie = !!detectIE();

    var _ignoreHashChange = false;

    var context = options.context;
    var baseUrl = window.location.href.split('?')[0].split('#')[0];
    var currentHash = window.location.hash.match(/(step)/g) === null ? '#step1' : window.location.hash;

    var isSingleStepMembership = context.attr('data-membershiptype') === 'Individual' || context.attr('data-membershiptype') === 'Joint' ? true : false;
    var isJointMembership = context.attr('data-membershiptype') === 'Joint' ? true : false;

    if (isSingleStepMembership) {
        currentHash = '#step3';
    }

    var currentStep = window.location.hash.match(/(#step\d+)/g) === null ? 1 : window.location.hash.replace(/(#step)/g, '');

    if (isSingleStepMembership) {
        currentStep = 3;
    }

    var previousStep, stateChange, subscribeScrollToError, subscribeScrollToElement;

    var stepPartialWrapper = context.find('[data-binding="step-partial-wrapper"]');
    var allStepPartialChildrenExceptAjaxLoading = stepPartialWrapper.find('> *').not('.ajax-loading');

    var ajaxLoading = $('.ajax-loading');

    var currentNumberOfMembers;
    var currentNumberOfYouthMembers = 0;
    var currentNumberOfAdultMembers = 0;

    if ($('[data-binding="add-youth-member-form"]').length) {
        currentNumberOfYouthMembers = $('[data-binding="add-youth-member-form"]').length - 1;
    }

    if ($('[data-binding="add-adult-member-form"]').length) {
        currentNumberOfAdultMembers = $('[data-binding="add-youth-member-form"]').length - 1;
    }

    var membershipGaEvent = {
        membershipType: context.attr('data-membershiptype')
    };

    var haveGoneBackwards = false;

    /**
     * Initialise the membership journey
     */
    function init() {
        // init 'state-change' subscription
        stateChange = subscribeStateChange();

        subscribeScrollToElement = subscribeScrollToElementFn();
        subscribeScrollToError = subscribeScrollToErrorFn();

        ajaxLoading.show();
        selectMembershipOption();
        $.validator.unobtrusive.parse(context.find('form'));

        updateGaMembershipDetails();
        hideDeleteButtons();

        addCustomClientSideValidation();

        // on load check to see if there is a hash
        if ((window.location.hash !== '' || getQueryVar('step') !== false) && !isSingleStepMembership) {

            var hash;
            var stepNumber;
            var url;
            var params;

            if (window.location.hash && !getQueryVar('step')) {
                // store hash in a variable
                hash = window.location.hash;
                stepNumber = hash.split('#step')[1];
            } else if (!window.location.hash && getQueryVar('step')) {
                // store step number variable
                stepNumber = getQueryVar('step');

                params = getAllQueryVars();

                if (params[0].key === 'step') {
                    // if the first url param is step
                    url = window.location.href.split('?');
                    url = window.location.href.replace(/(\?|\&)step=(\d+)/g, '?');
                    url = url.replace(/\?\&/g, '?');
                } else {
                    // if the first url param is not step
                    url = window.location.href.replace(/(\?|\&)step=(\d+)/g, '');
                }

                url = url + '#step' + stepNumber;
                window.location = url;
            } else {
                // there is a hash and a query variable
                var hashNumber = window.location.hash.replace(/(#step)/g, '');
                var queryVarNumber = getQueryVar('step');

                if (hashNumber === queryVarNumber) {
                    stepNumber = queryVarNumber;
                    url = window.location.href.replace(/(step=\d+)/, '').replace(/(#step)/g, '');
                    url = url + '#step' + stepNumber;
                    window.location = url;
                }
            }

            if (stepNumber !== '') {

                allStepPartialChildrenExceptAjaxLoading = stepPartialWrapper.find('> *').not('.ajax-loading');
                allStepPartialChildrenExceptAjaxLoading.remove();

                getPage(stepNumber).done(function (data) {
                    // see if the user has access to the page, otherwise rediret to landing page
                    var type = typeof data === 'undefined' ? 'undefined' : _typeof(data);
                    if (type === 'object' && data.result === 'Redirect') {

                        window.location = data.url;
                    } else if (type === 'string') {
                        var offsetTop = ajaxLoading.offset().top;
                        events.publish('scroll-to-element', {
                            offsetTop: offsetTop
                        });

                        setTimeout(function () {
                            stepPartialWrapper.append(data);

                            if (typeof window.HTMLPictureElement !== 'function') {
                                picturefill();
                            }

                            ajaxLoading.hide();

                            reinitPageModules(stepNumber);

                            selectMembershipOption();
                            $.validator.unobtrusive.parse(context.find('form'));
                            hideDeleteButtons();
                            initYouthMembershipOptions();
                        }, 1000);
                    }
                }).fail(function () {
                    window.location = window.location.protocol + '//' + window.location.host + '/ServerError.html';
                });
            }
        } else {
            ajaxLoading.hide();
        }

        if ('onhashchange' in window) {

            if (ie) {
                var oldHref = location.href;
                setInterval(function () {
                    var newHref = location.href;
                    if (oldHref !== newHref) {
                        var _oldHref = oldHref;
                        oldHref = newHref;
                        if (_ignoreHashChange === false) {
                            publishStateChange({
                                newUrl: newHref,
                                oldUrl: _oldHref,
                                type: 'GET'
                            });
                        }
                        _ignoreHashChange = false;
                    }
                }, 100);
            } else {
                $(window).on('hashchange', function (e) {

                    if (_ignoreHashChange === false) {
                        e.preventDefault();

                        publishStateChange({
                            newUrl: e.originalEvent.newURL,
                            oldUrl: e.originalEvent.oldURL,
                            type: 'GET'
                        });
                    }
                    _ignoreHashChange = false;
                });
            }
        }

        context.on('click', '[data-binding="membership-progress-link"]', function (e) {
            e.preventDefault();

            if ($(this).attr('href').indexOf('javascript') === -1) {

                var step = $(this).attr('href').split('step=')[1];
                var hash = '#step' + step;

                if (step !== '') {
                    var offsetTop = $('.membership-progress').offset().top;
                    events.publish('scroll-to-element', {
                        offsetTop: offsetTop
                    });

                    if (parseInt(step) === 1) {
                        window.location.hash = 'step1';
                    } else {
                        window.location.hash = hash;
                    }
                }
                if (step < currentStep) {
                    haveGoneBackwards = true;
                } else {
                    haveGoneBackwards = false;
                }
            }
        });

        context.on('click', '[data-binding="next-step"]', function (e) {
            e.preventDefault();
            var form = context.find('form');
            form.removeData('validator');
            form.removeData('unobtrusiveValidation');
            $.validator.unobtrusive.parse(form);

            var isValid = valid({
                context: this
            });

            if (isValid) {
                //prevent button being clicked multiple times
                $(this).prop('disabled', true);

                allStepPartialChildrenExceptAjaxLoading = stepPartialWrapper.find('> *').not('.ajax-loading');
                allStepPartialChildrenExceptAjaxLoading.hide();
                ajaxLoading.show();

                pushGaPartialCompletionDataLayer($(this).closest('fieldset').children('.membership-form-section__heading'));
                if (membershipGaEvent.membershipType === 'Family' || membershipGaEvent.membershipType === 'Youth') {
                    if ($(this).attr('id') === 'Step1') {
                        pushGAPricePoints();
                    }
                } else {
                    pushGAPricePoints();
                }

                var offsetTop = ajaxLoading.offset().top;
                events.publish('scroll-to-element', {
                    offsetTop: offsetTop
                });

                publishStateChange({
                    context: this,
                    type: 'POST'
                });
            } else {
                events.publish('scroll-to-error');
            }
        });

        context.on('change', '[data-binding="credit-card-expiry-month"]', function () {
            var creditCardExpiryYear = $('[data-binding="credit-card-expiry-year"]');

            var month = this.value < 10 ? '0' + this.value : this.value;
            var year = creditCardExpiryYear.val() === '' ? '' : creditCardExpiryYear.val();
            var expDate = $('#x_exp_date');

            expDate.val(month + year);

            if (month !== '0' && year !== '') {
                var date = new Date(parseInt(year), parseInt(month), 0);
                if (dateIsInThePast(date)) {
                    events.publish('custom-error', {
                        element: $(this),
                        message: 'Oh dear! It looks like your card has expired. Please can you use one that\'s still valid? Thanks!'
                    });
                } else {
                    events.publish('remove-custom-error', {
                        element: $(this)
                    });
                }
            }
        });

        context.on('change', '[data-binding="credit-card-expiry-year"]', function () {
            var creditCardExpiryMonth = $('[data-binding="credit-card-expiry-month"]');

            var month = creditCardExpiryMonth.val() < 10 ? '0' + creditCardExpiryMonth.val() : creditCardExpiryMonth.val();
            var year = this.value !== '' ? this.value : '';
            var expDate = $('#x_exp_date');

            expDate.val(month + year);

            if (month !== '0' && year !== '') {
                var date = new Date(parseInt(year), parseInt(month), 0);
                if (dateIsInThePast(date)) {
                    events.publish('custom-error', {
                        element: creditCardExpiryMonth,
                        message: 'Oh dear! It looks like your card has expired. Please can you use one that\'s still valid? Thanks!'
                    });
                } else {
                    events.publish('remove-custom-error', {
                        element: creditCardExpiryMonth
                    });
                }
            }
        });

        context.on('click', '[data-binding="credit-card-submit"]', function (e) {
            e.preventDefault();

            if ($(this).parents('form').valid() && $(this).prop('disabled') !== true) {
                var button = $(this);
                button.prop('disabled', true);
                button.find('.button__text').text('Submitting...');
                button.parents('form').submit();
            } else {
                events.publish('scroll-to-error');
            }
        });

        context.on({
            keyup: function keyup() {
                var cardType = getCreditCardType(this.value);
                var cardTypeWrapper = $('[data-binding="credit-card-payment-card-types"]');

                if (cardType !== 'unknown') {
                    cardTypeWrapper.children().addClass('inactive');

                    if (cardType === 'visa') {
                        cardTypeWrapper.find('.icon-visa').removeClass('inactive');
                    } else if (cardType === 'mastercard') {
                        cardTypeWrapper.find('.icon-mastercard').removeClass('inactive');
                    } else if (cardType === 'solo') {
                        cardTypeWrapper.find('.icon-solo').removeClass('inactive');
                    }
                } else {
                    cardTypeWrapper.children().addClass('inactive');
                }
            },
            blur: function blur() {
                var cardType = getCreditCardType(this.value);
                if (cardType === 'unknown') {
                    events.publish('custom-error', {
                        element: $(this),
                        message: 'Sorry - we don\'t accept this type of card.'
                    });
                }
            }
        }, '[data-binding="credit-card-number"]');

        context.on('click', '[data-binding="add-youth-member-button"]', function (e) {
            e.preventDefault();
            var allAddYouthMemberForms = $(this).siblings('[data-binding="add-youth-member-form"]');
            var currentAddMemberForm = allAddYouthMemberForms.last();
            var firstName = currentAddMemberForm.find('[data-binding="youth-membership-first-name"]');
            var lastName = firstName.parents('.field-group').find('[data-binding="youth-membership-last-name"]');
            var dobFields = currentAddMemberForm.find('[data-binding="youth-membership-date-select"]');
            var form = context.find('form');

            // reset the unobtrusive validation
            form.removeData('validator');
            form.removeData('unobtrusiveValidation');
            $.validator.unobtrusive.parse(form);
            addCustomClientSideValidation();

            var firstNameValid,
                lastNameValid,
                dobValid = null;

            firstNameValid = form.validate().element(firstName);
            lastNameValid = form.validate().element(lastName);

            var invalidCount = 0;
            for (var i = 0; i < dobFields.length; i++) {
                if (form.validate().element(dobFields[i]) === false) {
                    ++invalidCount;
                }

                if (invalidCount === 0) {
                    dobValid = true;
                } else {
                    dobValid = false;
                }
            }

            // check whether it's a youth or family journey and adjust the number of yout memeber allowed accordingly
            if (currentNumberOfYouthMembers < 5) {

                if (firstNameValid && lastNameValid && dobValid) {

                    events.publish('clone-member', {
                        context: $(this),
                        toClone: $(this).siblings('[data-binding="add-youth-member-form"]').last(),
                        type: 'familyYouth'
                    });

                    if (currentNumberOfYouthMembers === 4) {
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                } else {
                    events.publish('scroll-to-error');
                }
            }
        });

        context.on('click', '[data-binding="add-adult-member-button"]', function (e) {
            e.preventDefault();
            var currentAddMemberForm = $(this).siblings('[data-binding="add-adult-member-form"]').last();
            var title = currentAddMemberForm.find('[data-binding="adult-membership-title"]');
            var firstName = currentAddMemberForm.find('[data-binding="adult-membership-first-name"]');
            var lastName = firstName.parents('.field-group').find('[data-binding="adult-membership-last-name"]');
            var email = firstName.parents('.adult-members').find('[data-binding="adult-membership-email"]');

            var form = context.find('form');
            form.removeData('validator');
            form.removeData('unobtrusiveValidation');
            $.validator.unobtrusive.parse(form);

            var titleValid = form.validate().element(title);
            var firstNameValid = form.validate().element(firstName);
            var lastNameValid = form.validate().element(lastName);
            var emailValid = form.validate().element(email);

            if (currentNumberOfAdultMembers < 2) {

                if (titleValid && firstNameValid && lastNameValid && emailValid) {

                    events.publish('clone-member', {
                        context: $(this),
                        toClone: $(this).siblings('[data-binding="add-adult-member-form"]').last(),
                        type: 'adult'
                    });

                    if (currentNumberOfAdultMembers === 1) {
                        $(this).hide();
                    }
                } else {
                    events.publish('scroll-to-error');
                }
            }
        });

        context.on('click', '[data-binding="delete-member-button"]', function (e) {
            e.preventDefault();

            var form = $(this).parents('[data-binding="add-youth-member-form"], [data-binding="add-adult-member-form"]');
            var siblings = form.siblings('[data-binding="add-youth-member-form"], [data-binding="add-adult-member-form"]');
            var binding = form.data('binding');

            var addMemberButton = null;

            if (binding === 'add-youth-member-form') {
                addMemberButton = form.parents('.youth-members').find('[data-binding="add-youth-member-button"]');
                --currentNumberOfYouthMembers;

                if (currentNumberOfYouthMembers > 0 && currentNumberOfYouthMembers < 4) {
                    addMemberButton.show();
                }
            } else {
                addMemberButton = form.parents('.adult-members').find('[data-binding="add-adult-member-button"]');
                --currentNumberOfAdultMembers;
                if (currentNumberOfAdultMembers === 0) {
                    addMemberButton.show();
                }
            }

            form.remove();

            events.publish('reindex-add-member-forms', {
                binding: binding,
                context: $(this),
                form: form,
                siblings: siblings
            });

            if (context.find('[data-binding*="youth-price-option"]').length > 0) {
                if (context.find('[data-binding*="youth-price-option"]:checked').parents('[data-binding="multiple-child-radio-option"]').length > 0) {
                    hideDeleteButtons(2);
                } else {
                    hideDeleteButtons();
                }
            } else {
                hideDeleteButtons();
            }
        });

        context.on('change', '[data-binding*="same-or-different-billing-address"]', function () {
            // Disable on Individual and Joint as taken care in form-multiple-address.js
            if (!isSingleStepMembership) {
                var type = $(this).data('binding').split(' ')[1];
                var parentFieldGroup = $(this).parents('.field-group');
                var addressLookup = parentFieldGroup.siblings('.address-lookup');
                var postcodeInputField = addressLookup.find('[data-binding="postcode-lookup-input-field"]');

                if (type === 'different-address') {
                    addressLookup.show();
                } else {
                    addressLookup.hide();
                    postcodeInputField.val('');
                    resetBillingAddress();
                }
            }
        });

        context.on('change', '[data-binding*="SendPackToPayer"]', function () {
            // Disable on Individual and Joint as taken care of by backend
            if (!isSingleStepMembership) {
                var type = $(this).data('binding').split(' ')[1];

                var CreditCardSendPackToPayer = $('#CreditCardSendPackToPayer');
                if (type === 'SendToPayer') {
                    CreditCardSendPackToPayer.val(true);
                } else {
                    CreditCardSendPackToPayer.val(false);
                }
            }
        });

        context.on('click', '[data-radio-option]', function () {
            var $this = $(this);
            var parent = $(this).parent();
            var customAmount = $this.siblings('.membership-radio-option--custom-amount');

            if ($this.prop('checked') !== true) {
                parent.find('[data-radio-option]').removeClass('selected');
                parent.find('input[type="radio"]').prop('checked', false);
                $this.find('input[type="radio"]').prop('checked', true).change();
                $this.addClass('selected');

                if ($this.hasClass('custom-amount')) {
                    $this.find('input[type=text]').focus();
                } else {
                    customAmount.find('input[type=text]').val('').blur();
                }
                updateGaMembershipDetails();
            }
        });

        context.on({
            focus: function focus() {
                $(this).addClass('focus');
            },
            blur: function blur() {
                $(this).removeClass('focus');
            }
        }, '[data-radio-option]');

        context.on('click', '[data-behavior="membership-summary-button"]', function (e) {
            e.preventDefault();
            var list = $(this).siblings('[data-behavior="membership-summary-list"]');

            $(this).parent().toggleClass('open');
            list.slideToggle();
        });

        context.on('change', '[data-binding*="youth-price-option"]', function () {
            var isLeftOption = $(this).parents('[data-binding="single-child-radio-option"]').length > 0;
            var allAddYouthForms = $('[data-binding="add-youth-member-form"]');
            var addMemberButton = $('[data-binding="add-youth-member-button"]');
            if (isLeftOption) {
                addMemberButton.addClass('hidden');
                if (allAddYouthForms.length > 1) {
                    var notFirst = allAddYouthForms.filter(':gt(0)');
                    notFirst.find('[data-binding="delete-member-button"]').click();
                }
            } else {
                if (allAddYouthForms.length === 1) {
                    addMemberButton.removeClass('hidden');
                    events.publish('clone-member', {
                        context: addMemberButton,
                        toClone: allAddYouthForms.last(),
                        type: 'youth'
                    });
                    hideDeleteButtons(2);
                }
            }
        });
        initYouthMembershipOptions();

        context.on('keyup', '[data-binding="sort-code"]', function () {
            // Get input from sort code field, create array of characters
            var input = $(this).val().split('');

            // If input length is 2 or longer, move cursor to next niput field
            if (input.length === 2) {
                $(this).next().focus();
            }
        });

        context.on('click', '[data-binding="submit-individual-membership-form"]', function (e) {
            var formsValid = true;

            // Before allowing membership form processing we need to check the inner credit card form too.
            // We trigger form valiation for the membership form as well otherwise only credit card form would 
            // display any errors.
            $.each(context.find('form'), function (key, form) {
                formsValid &= $(form).valid();
            });

            if (formsValid) {
                $('#x_email').val($('#ContactDetails_EmailAddress').val());
                $('[data-binding="next-step"]').click();
            } else {
                events.publish('scroll-to-error');
                e.preventDefault();
            }
        });

        context.on('change', '[data-binding="adult-membership-title"]', function () {
            if (isJointMembership && gift === 'False' && $(this).attr('id') === 'Member1_Title') {
                $('#ContactDetails_Title').val($(this).val());
            }
        });

        context.on('keyup', '[data-binding="adult-membership-first-name"]', function () {
            if (isJointMembership && gift === 'False') {
                if ($(this).attr('id') === 'Member1_FirstName') {
                    $('#ContactDetails_FirstName').val($.trim($(this).val()));
                    $('#AccountPayment_GiftAid_member-name1').text($.trim($(this).val()) + ' ' + $.trim($('#Member1_LastName').val()));
                }

                if ($(this).attr('id') === 'Member2_FirstName') {
                    $('#AccountPayment_GiftAid_member-name2').text($.trim($(this).val()) + ' ' + $.trim($('#Member2_LastName').val()));
                }
            }
        });

        context.on('keyup', '[data-binding="adult-membership-last-name"]', function () {
            if (isJointMembership && gift === 'False') {
                if ($(this).attr('id') === 'Member1_LastName') {
                    $('#ContactDetails_LastName').val($.trim($(this).val()));
                    $('#AccountPayment_GiftAid_member-name1').text($.trim($('#Member1_FirstName').val()) + ' ' + $.trim($(this).val()));
                }

                if ($(this).attr('id') === 'Member2_LastName') {
                    $('#AccountPayment_GiftAid_member-name2').text($.trim($('#Member2_FirstName').val()) + ' ' + $.trim($(this).val()));
                }
            }
        });

        context.on('keyup', '[data-binding="adult-membership-email"]', function () {
            if (isJointMembership && gift === 'False' && $(this).attr('id') === 'Member1_EmailAddress') {
                $('#ContactDetails_EmailAddress').val($.trim($(this).val()));
            }
        });
    }

    function reinitPageModules(page) {
        if (page === '2' || page === 2) {
            // manually enable the GDPR opt-in module as it wasn't present on a page load
            reinitModules([{
                name: 'gdpr-preferences',
                module: require('../modules/gdpr-preferences')
            }]);
        }
    }

    /**
     * Update the price displayed on payment options
     */
    function updatePaymentMethodPrice(amount) {
        var price = amount.replace('.00', '');
        var priceAnnual = price * 12;
        var paymentMonthlyLabel;
        var paymentAnnuallyLabel;
        var paymentAnnualyCardLabel;

        // Restrict decimal places to 2
        // Remove decimal places if they are 00
        priceAnnual = priceAnnual.toFixed(2);

        // update hidden x_amount field for credit card submit
        $('input[name="x_amount"]').val(priceAnnual);
        priceAnnual = priceAnnual.replace('.00', '');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentMonthlyLabel = $('#payment-monthly').next();
        paymentMonthlyLabel.contents().last().remove();
        paymentMonthlyLabel.append('£' + price + ' via direct debit');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentAnnuallyLabel = $('#payment-annually').next();
        paymentAnnuallyLabel.contents().last().remove();
        paymentAnnuallyLabel.append('£' + priceAnnual + ' via direct debit');

        // Get the monthly payment label, remove text node with amount and append new text node with update amount
        paymentAnnualyCardLabel = $('#payment-oneoff').next();
        paymentAnnualyCardLabel.contents().last().remove();
        paymentAnnualyCardLabel.append('£' + priceAnnual + ' via credit / debit card');
    }

    /**
     * Updates the internally stored variable for the previousStep
     */
    function updatePreviousStep() {
        previousStep = currentStep;
    }

    /**
     * In creases the current step by one and updates the previous step variable
     */
    function incrementCurrentStep() {
        updatePreviousStep();
        ++currentStep;
    }

    /**
     * Increment the internally stored hash varibable by 1
     */
    function incrementInternalHash() {
        currentHash = currentHash.replace(/(#step)(\d+)/, function (n, group1, group2) {
            var newHash = group1 + (parseInt(group2) + 1);
            return newHash;
        });
    }

    /**
     * Update hte hash string in the URL
     */
    function updateBrowserHash() {
        window.location.hash = currentHash;
    }

    /**
     * Publish the 'state-changed' event
     * @param  { Object } options - a key value set of options to be passed to the subscribe function
     */
    function publishStateChange(options) {
        events.publish('state-changed', options);
    }

    /**
     * Subscribe to the 'state-changed' event
     * @return { function } returns subscribe event so that it can be cancelled if needs be
     */
    function subscribeStateChange() {
        return events.subscribe('state-changed', function (obj) {

            if (obj.type === 'POST') {
                submitForm().done(function (data) {

                    var type = typeof data === 'undefined' ? 'undefined' : _typeof(data);
                    if (type === 'object' && data.result === 'Redirect') {

                        window.location = data.url;
                    } else if (type === 'object' && data.result === 'OperationSuccessful') {

                        // Individual membership contact details saved, trigger credit card submit
                        var expMonth = $('#ExpiryMonth').val();
                        if (expMonth < 10) expMonth = '0' + expMonth;

                        var ccform = data.ccform;
                        ccform = ccform.replace('CCNUM', $('#x_card_num').val());
                        ccform = ccform.replace('CCCODE', $('#x_card_code').val());
                        ccform = ccform.replace('CCEM', $('#ExpiryMonth').val());
                        ccform = ccform.replace('CCEY', $('#ExpiryYear').val());
                        ccform = ccform.replace('CCED', expMonth + $('#ExpiryYear').val());

                        var ccformhtml = $.parseHTML(ccform);
                        var formId = $('.credit-card-payment form #FormId');
                        $('.credit-card-payment').empty().append(ccformhtml);
                        $('.credit-card-payment form').append(formId);
                        $('.credit-card-payment form').submit();
                    } else if (type === 'string') {
                        var html = $.parseHTML(data);

                        if ($(html).find('#Step').val() > currentStep) {
                            _ignoreHashChange = true;
                            incrementCurrentStep();
                            incrementInternalHash();
                            updateBrowserHash();
                        }

                        allStepPartialChildrenExceptAjaxLoading = stepPartialWrapper.find('> *').not('.ajax-loading');
                        allStepPartialChildrenExceptAjaxLoading.remove();

                        setTimeout(function () {
                            stepPartialWrapper.append(data);

                            if (typeof window.HTMLPictureElement !== 'function') {
                                picturefill();
                            }

                            $.validator.unobtrusive.parse(context.find('form'));
                            selectMembershipOption();
                            hideDeleteButtons();
                            ajaxLoading.hide();
                            pushGaDataLayer();

                            reinitPageModules(currentStep);

                            if (isSingleStepMembership) {
                                selectPaymentOption();
                                // update custom amount price on membership payment methods on page reload
                                if ($('#PriceOptions_CustomAmount').val() !== '') {
                                    updatePaymentMethodPrice($('#PriceOptions_CustomAmount').val());
                                }
                            }
                        }, 1000);
                    }
                }).fail(function () {
                    window.location = window.location.protocol + '//' + window.location.host + '/ServerError.html';
                });
            }

            if (obj.type === 'GET') {

                var hash = null;
                var stepNumber = null;

                if (obj.newUrl.indexOf('#step') === -1) {
                    hash = '#step1';
                    stepNumber = 1;
                } else {
                    hash = '#' + obj.newUrl.split('#')[1];
                    stepNumber = parseInt(obj.newUrl.split('#step')[1]);
                }

                currentHash = hash;
                currentStep = stepNumber;

                getPage(stepNumber).done(function (data) {

                    var type = typeof data === 'undefined' ? 'undefined' : _typeof(data);
                    if (type === 'object' && data.result === 'Redirect') {

                        window.location = data.url;
                    } else if (type === 'string') {

                        allStepPartialChildrenExceptAjaxLoading = stepPartialWrapper.find('> *').not('.ajax-loading');
                        allStepPartialChildrenExceptAjaxLoading.remove();

                        ajaxLoading.show();

                        var offsetTop = ajaxLoading.offset().top;
                        events.publish('scroll-to-element', {
                            offsetTop: offsetTop
                        });

                        setTimeout(function () {
                            stepPartialWrapper.append(data);

                            if (typeof window.HTMLPictureElement !== 'function') {
                                picturefill();
                            }

                            reinitPageModules(stepNumber);

                            $.validator.unobtrusive.parse(context.find('form'));
                            selectMembershipOption();
                            hideDeleteButtons();
                            ajaxLoading.hide();
                        }, 1000);
                    }
                }).fail(function () {
                    window.location = window.location.protocol + '//' + window.location.host + '/ServerError.html';
                });
            }
        });
    }

    /**
     * Updates the values of the ga object
     */
    function updateGaMembershipDetails() {
        membershipGaEvent.priceOption = context.find('[data-binding~="price-input-option"]:checked').val();
        membershipGaEvent.customPriceOption = context.find('[data-binding="custom-price-input-option"]:checked').siblings('input').val();
        membershipGaEvent.giftOption = context.find('[data-binding="gift-input-option"]:checked').val();
    }

    /**
     * Google tag manager function
     */
    function pushGaDataLayer() {
        var formContent = '';
        if (membershipGaEvent.customPriceOption) {
            formContent += 'Amount: ' + membershipGaEvent.customPriceOption;
        }

        if (membershipGaEvent.priceOption) {
            formContent += 'Amount: ' + membershipGaEvent.priceOption;
        }

        if (membershipGaEvent.giftOption) {
            if (formContent.length > 0) {
                formContent += ' - ';
            }

            formContent += 'Gift code: ' + membershipGaEvent.giftOption;
        }

        if ($('.validation-summary-valid').length) {
            dataLayer.push({ 'event': 'membershipStepComplete', 'membershipType': membershipGaEvent.membershipType, 'stepNumber': currentStep - 1, 'submittedData': formContent });
        }

        updateGaMembershipDetails();
    }

    function pushGaPartialCompletionDataLayer(completedSection) {
        var membershipType = membershipGaEvent.membershipType;

        // var membershipStep = currentStep;

        var membershipStepSection = $(completedSection).contents().first().text();
        membershipStepSection = membershipStepSection.replace(/(^\s+|\s+$)/g, '');

        if (haveGoneBackwards === false) {
            dataLayer.push({ 'event': 'membershipSectionComplete', 'membershipType': membershipType, 'stepNumber': currentStep, 'sectionName': membershipStepSection });
        }
    }

    function pushGAPricePoints() {
        var membershipType = membershipGaEvent.membershipType;
        var membershipPriceOption = 'Custom';

        if (membershipGaEvent.priceOption) {
            membershipPriceOption = membershipGaEvent.priceOption;
        }

        dataLayer.push({ 'event': 'membershipPricePoints', 'membershipPriceOptionType': membershipType, 'membershipPriceOptionValue': membershipPriceOption });
    }

    /**
     * Wrapper for the AJAX get method
     * @param  { int } step - the number of the step the be retrieved
     * @return { promise } returns the results of ajax query only if there are any
     */
    function getPage(step) {

        var params = getAllQueryVars();

        var fid = '';

        for (var i = 0; i < params.length; i++) {
            if (params[i].key === 'fid') {
                fid = params[i].value;
            }
        }

        var url = baseUrl + '?step=' + step;

        if (fid !== '') {
            url = url + '&fid=' + fid;
        }

        return $.ajax({
            cache: false,
            type: 'GET',
            url: url
        });
    }

    /**
     * Wrapper for an AJAX POST method that submits the current form and puts the results of POSTing the form
     * @return { promise } the results of POSTing the form
     */
    function submitForm() {
        var formData = context.find('form').serialize() + '&Step' + currentStep + '=';
        return $.ajax({
            context: context,
            data: formData,
            type: 'POST',
            url: context.find('form').attr('action')
        });
    }

    /**
     *
     */
    function selectMembershipOption() {
        var $membershipOption = context.find('[data-radio-option]');

        $.each($membershipOption, function (index, elem) {
            if ($(elem).find('input[type="radio"]').prop('checked') === true) {
                $(elem).addClass('selected');
            }
        });
    }

    /**
     *
     */
    function selectPaymentOption() {
        if ($('#payment-oneoff').prop('checked') === true) {
            $('.credit-card-payment').show();
            $('.direct-debit-payment').hide();
        } else {
            $('.credit-card-payment').hide();
            $('.direct-debit-payment').show();
        }
    }

    /**
     * Returns the type fo the credit card as a user types
     * @param  { int } cardNumber - the number of the credit card that the user has entered
     * @return { String } results - the name of the credit card provider or unknown if nothing is found
     */
    function getCreditCardType(cardNumber) {

        var result = 'unknown';

        // check for MasterCard
        if (/^5[1-5]/.test(cardNumber)) {
            result = 'mastercard';
        }

        // check for Visa
        else if (/^4/.test(cardNumber)) {
                result = 'visa';
            }

            // check for Solo
            else if (/^6334|6767$/.test(cardNumber)) {
                    result = 'solo';
                }

        return result;
    }

    /**
     * Reset the hidden billing address fields to the membership address
     */
    function resetBillingAddress() {

        var hiddenAddress = $('#x_address');
        var hiddenTown = $('#x_city');
        var hiddenCounty = $('#x_state');
        var hiddenPostcode = $('#x_zip');
        var hiddenCountry = $('#x_country');
        var hiddenBillingAddress = $('#DifferentBillingAddress');

        if (hiddenAddress.length > 0) {
            hiddenAddress.val(hiddenAddress.data('membership-address'));
            hiddenTown.val(hiddenTown.data('membership-address'));
            hiddenCounty.val(hiddenCounty.data('membership-address'));
            hiddenPostcode.val(hiddenPostcode.data('membership-address'));
            hiddenCountry.val(hiddenCountry.data('membership-address'));
            hiddenBillingAddress.val(false);
        }
    }

    function hideDeleteButtons(members) {
        var minimumMembers = members || 1;

        var addAdultMemberForms = $('[data-binding="add-adult-member-form"]');
        var addYouthMemberForms = $('[data-binding="add-youth-member-form"]');

        var allAdultDeleteButtons = addAdultMemberForms.find('[data-binding="delete-member-button"]');
        var allYouthDeleteButtons = addYouthMemberForms.find('[data-binding="delete-member-button"]');

        if (addAdultMemberForms.length === minimumMembers) {
            var first = allAdultDeleteButtons.first();
            first.hide();
        }

        if (addYouthMemberForms.length <= minimumMembers) {
            allYouthDeleteButtons.hide();
        }
    }

    function showDeleteButtons(options) {
        var type = options.type;
        var minimumMembers = options.members || 1;

        if (type === 'adult') {
            var addAdultMemberForms = $('[data-binding="add-adult-member-form"]');
            var allAdultDeleteButtons = addAdultMemberForms.length === minimumMembers ? addAdultMemberForms.not(':first').find('[data-binding="delete-member-button"]') : addAdultMemberForms.find('[data-binding="delete-member-button"]');
            allAdultDeleteButtons.show();
        } else {
            var addYouthMemberForms = $('[data-binding="add-youth-member-form"]');
            var allYouthDeleteButtons = addYouthMemberForms.length <= minimumMembers ? addYouthMemberForms.not(':eq(' + minimumMembers + ')').find('[data-binding="delete-member-button"]') : addYouthMemberForms.find('[data-binding="delete-member-button"]');
            allYouthDeleteButtons.show();
        }
    }

    function subscribeScrollToElementFn() {
        return events.subscribe('scroll-to-element', function (obj) {
            $('html, body').animate({
                scrollTop: obj.offsetTop
            }, 500);
        });
    }

    function subscribeScrollToErrorFn() {
        return events.subscribe('scroll-to-error', function () {
            var firstError = context.find('.field-validation-error').first();
            if (firstError.length === 0) {
                firstError = context.find('.input-validation-error').first();
            }

            var firstErrorSectionContent = firstError.parents('.membership-form-section__content');
            var errorInput = firstError.siblings('input, select');

            if (firstError.parents('[data-binding="edit-address-fields"]').length > 0) {
                $('[data-binding="edit-address-fields"]').slideDown();
            }

            firstErrorSectionContent.slideDown(function () {
                var offsetTop = errorInput.length > 0 ? errorInput.offset().top : firstError.offset().top;
                $('html, body').animate({
                    scrollTop: offsetTop
                }, 500);
            });
        });
    }

    function replaceNamesAndIdsForAdultAndYouthMembers(html, numberToReplaceCurrentNumber) {
        var regexForIds = new RegExp('(\\d__)', 'g');
        var regexForNames = new RegExp('(\\[\\d\\])', 'g');

        html = html.replace(regexForIds, function (match) {
            return match.replace(/(\d)/g, numberToReplaceCurrentNumber);
        });

        html = html.replace(regexForNames, function (match) {
            return match.replace(/(\d)/g, numberToReplaceCurrentNumber);
        });

        return html;
    }

    function initYouthMembershipOptions() {
        context.find('[data-binding*="youth-price-option"]').first().trigger('change');
    }

    function isInputEmpty(field) {
        return field.val() === '';
    }

    function valid(options) {
        var localContext = options.context;
        var isValid = true;

        var checkedRadioButtonExists = $('[data-binding*="same-or-different-billing-address"]:checked').length > 0;
        var postcodeField = context.find('[data-binding="postcode-lookup-input-field"]');
        var postcodeFieldExists = postcodeField.length > 0;

        if (postcodeFieldExists || checkedRadioButtonExists) {

            var isSameAddress = $('[data-binding*="same-or-different-billing-address"]:checked');
            isSameAddress = isSameAddress.length > 0 ? isSameAddress.data('binding').indexOf('same-address') !== -1 : false;

            var restOfFormIsValid = context.find('form').valid();

            if (checkedRadioButtonExists && isSameAddress) {
                var formElements = $(localContext).parents('form').find('input, select').not('input[type="hidden"], [data-binding="postcode-lookup-input-field"], [data-binding="address-part-street-address"], [data-binding="address-part-town"]');

                for (var i = 0; i < formElements.length; i++) {
                    var element = formElements[i];
                    if (context.find('form').validate().element(element)) {
                        isValid = true;
                        continue;
                    } else {
                        isValid = false;
                        break;
                    }
                }

                return isValid;
            } else {
                var isPostcodeEmpty;
                var manualAddressExists = $('[data-binding="edit-address-fields"]').length > 0;
                var manualAddressDisplay;

                if (postcodeFieldExists) {
                    isPostcodeEmpty = isInputEmpty(postcodeField);
                }

                if (manualAddressExists) {
                    manualAddressDisplay = $('[data-binding="edit-address-fields"]').css('display');
                }

                if (postcodeFieldExists && isPostcodeEmpty && manualAddressDisplay !== 'block') {
                    events.publish('custom-error', {
                        element: postcodeField,
                        message: 'What\'s the UK postcode of the address?'
                    });
                    isValid = false;
                }

                if (manualAddressExists && manualAddressDisplay === 'block') {
                    var fields = $('[data-binding="address-part-street-address"], [data-binding="address-part-town"]');

                    for (var fieldCounter = 0; fieldCounter < fields.length; fieldCounter++) {
                        if (context.find('form').validate().element(fields[fieldCounter])) {
                            continue;
                        } else {
                            isValid = false;
                            break;
                        }
                    }
                }

                if (restOfFormIsValid === false) {
                    isValid = false;
                }

                return isValid;
            }
        } else {
            return context.find('form').valid();
        }
    }

    /**
     * Function for determining if a date is in the past
     * @param  { Date } date -
     * @return { boolean } returns true if the date is in the past otherwise returns false
     */
    function dateIsInThePast(date) {
        var today = new Date();
        var isInThePast = date < today;

        if (isInThePast) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Extends the expressive annotations to check if a youth member is over the age of 18
     */
    function addCustomClientSideValidation() {

        ea.addMethod('IsUnderAge', function (maxAge, year, month, day) {

            if (!year || !month || !day) {
                return true; // user hasn't completed selection
            }

            var getAgeFromDateOfBirth = function getAgeFromDateOfBirth(dob) {
                var today = new Date();
                var age = today.getFullYear() - dob.getFullYear();

                dob.setFullYear(dob.getFullYear() + age);
                if (dob > today) {
                    age--;
                }

                return age;
            };

            var dob = new Date(year, month - 1, day);
            var age = getAgeFromDateOfBirth(dob);
            return age < maxAge;
        });
    }

    events.subscribe('clone-member', function (options) {

        var context = options.context;
        var elementToBeCloned = options.toClone;
        var clone = elementToBeCloned.clone();
        var dobFields = clone.find('[data-binding="youth-membership-date-select"]');

        if (dobFields.length) {
            for (var i = 0; i < dobFields.length; i++) {
                var selectedOption = $(dobFields[i]).find('option:selected');
                var index = $(dobFields[i]).prop('selectedIndex');
                var newOption = $('<option/>').val(selectedOption.val()).text(selectedOption.text());

                $(dobFields[i]).find('option:selected').remove();
                $(dobFields[i]).find('option').eq(index).before(newOption);
            }
        }

        if (options.type === 'adult') {
            currentNumberOfMembers = currentNumberOfAdultMembers;
        } else {
            currentNumberOfMembers = currentNumberOfYouthMembers;
        }

        clone = clone[0].outerHTML;

        clone = replaceNamesAndIdsForAdultAndYouthMembers(clone, currentNumberOfMembers + 1);

        clone = $(clone);
        clone.find('[data-binding="member-title"]').text(function () {
            return $(this).text().replace(/(\d)/g, currentNumberOfMembers + 2);
        });
        clone.find('input[type="text"]').val('').removeClass('input-validation-error ').addClass('valid');

        context.before(clone);

        currentNumberOfMembers++;
        showDeleteButtons({
            type: options.type
        });

        if (options.type === 'adult') {
            currentNumberOfAdultMembers = currentNumberOfMembers;
        } else {
            currentNumberOfYouthMembers = currentNumberOfMembers;
        }
    });

    events.subscribe('reindex-add-member-forms', function (obj) {
        var allMemberForms = obj.siblings;

        $.each(allMemberForms, function (index, item) {
            var values = [];
            var oldFormsInputs = $(item).find('input, select');
            $.each(oldFormsInputs, function (index, item) {
                values.push($(item).val());
            });

            var html = replaceNamesAndIdsForAdultAndYouthMembers(item.outerHTML, index);
            html = $(html).children();
            var newFormInputs = html.find('input, select');

            for (var i = 0; i < newFormInputs.length; i++) {
                $(newFormInputs[i]).val(values[i]);
            }

            $(item).html(html);
            $(item).find('[data-binding="member-title"]').text(function () {
                var text = $(this).text();
                var replace = text.replace(/(\d)/g, index + 1);
                return replace;
            });
        });
    });

    events.subscribe('custom-error', function (options) {
        var element = options.element;
        var message = options.message;
        var errorSpan = element.siblings('[class*="field-validation"]');
        errorSpan.removeClass('field-validation-valid').addClass('field-validation-error').text(message);
    });

    events.subscribe('remove-custom-error', function (options) {
        var element = options.element;
        var errorSpan = element.siblings('[class*="field-validation"]');
        errorSpan.removeClass('field-validation-error').addClass('field-validation-valid').empty();
    });

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/membership-journey.js
// module id = 183
// module chunks = 0